<div class="page">
	<div>
		<h1 [innerHTML]="title"></h1>
		<p [innerHTML]="subtitle" class="text-secondary"></p>
		<button class="mt-5 p-3" *ngIf="buttonName" mat-flat-button color="accent"
		>{{buttonName}}</button>
	</div>
	<img [src]="imageUrl" [alt]="imageAlt" [style.width]="imageWidth">
</div>